import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Button, Icon } from 'semantic-ui-react'
import FieldsMappingForm from './FieldsMappingForm'

export default class ImportModal extends React.Component {
  static propTypes = {
    open: PropTypes.bool,
    mappings: PropTypes.array,
    excelRows: PropTypes.array.isRequired,
    onCancel: PropTypes.func,
    onImport: PropTypes.func,
    onAddMapping: PropTypes.func,
    columns: PropTypes.array
  }

  static defaultProps = {
    open: false
  }

  render() {
    return (
      <Modal
        open={this.props.open}
        centered={false}
        size='small'
      >
        <Modal.Header>Import Excel WorkSheet</Modal.Header>
        <Modal.Content>
          <FieldsMappingForm
            excelRows={this.props.excelRows}
            mappings={this.props.mappings}
            columns={this.props.columnNames}
            onAddMapping={this.props.onAddMapping}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={this.props.onCancel}>
            Cancel
          </Button>
          <Button primary onClick={this.props.onImport}>
            Import   <Icon style={{marginLeft: "2px"}} name='cloud upload' />
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./components/create-order/ImportModal.js